import { Action } from '../../shared/models/action.model';
import { updateAction } from '../../utils/utility';
import { AbdmFilters } from '../models/abdmHIUModel';
import actionTypes from '../types/abdmHiuTypes';

export const saveRequestConcent = (formData: any, onSuccess: any, onError: any): Action<any> =>
  updateAction(actionTypes.SAVE_REQUEST_CONCENT, { formData, onSuccess, onError });

export const searchHealthId = (healthId: any, callBack: any): Action<any> =>
  updateAction(actionTypes.SEARCH_FOR_HEALTH_ID, { healthId, callBack });

export const registerForHIU = (onSuccess: any, onError: any, facilityId?: string): Action<any> =>
  updateAction(actionTypes.REGISTER_FOR_HIU, { facilityId, onSuccess, onError });

export const fetchConsentList = (callBack: any): any =>
  updateAction(actionTypes.FETCH_CONCENT_LIST, { callBack });

export const reloadHIUList = (): Action<void> =>
  updateAction(actionTypes.RELOAD_HIU_LIST);

export const applyFilters = (filter: AbdmFilters): Action<any> =>
  updateAction(actionTypes.APPLY_FILTER, filter);

export const getConcentDetail = (concentId: any, onSuccess: any): Action<any> =>
  updateAction(actionTypes.GET_CONCENT_DETAIL, { concentId, onSuccess });

export const searchClicked = (): Action<any> => {
   return updateAction(actionTypes.SEARCH_CLICKED );
  };

export const setFilter = (payload: any): Action<any> => {
  return updateAction(actionTypes.SET_FILTER, payload);
};

export const resetFilter = (payload: any): Action<any> => {
  return updateAction(actionTypes.RESET_FILTER, payload);
};
